<template>
  <!-- 上游费用配置 -->
  <div class="main-container">
    <div class="left-box">
      <div class="input-box">
        <Input class="input" v-model="keyword" placeholder="请输入供应商搜索" @on-enter="getSupplierList()" />
        <Icon type="ios-search" class="search-icon" @click="getSupplierList()" />
        <Poptip trigger="hover" placement="top" transfer-class-name="my-poptip left0 min" :transfer="true">
          <i class="iconfont icondaoru2 daoru-icon" @click="$refs.importSupplier.open()"></i>
          <div slot="content">
            <p>导入供应商</p>
          </div>
        </Poptip>
      </div>
      <div class="list-box">
        <div class="list-item" :class="{ active: bean.leftId == leftId }" v-for="(bean, i) in supplierList" :key="i" @click="selectSupplier(bean)">
          {{ bean.companyName }}
        </div>
        <div class="empty-text" v-if="!leftLoading && supplierList.length == 0">
          <span>无该供应商，请导入供应商，或前往供应商管理维护，</span>
          <span class="btn" @click="$router.push('/offline/insuranceManage/insuranceManage')">{{ '去维护>>' }}</span>
        </div>
      </div>
      <div class="list-item bottom-item" :class="{ active: -1 == leftId }" @click="selectSupplier({ leftId: -1, companyName: '未配置供应商' })">
        <span class="dian red"></span>
        <span>未配置供应商</span>
      </div>
    </div>
    <div class="right-box">
      <loading :isShow="listLoading" />
      <div class="info-box">
        <div class="name">{{ curSupplierName }}</div>
        <div class="num" v-if="leftId != -1">（签约产品数量：{{ count }}）</div>
        <div class="info-text" v-if="leftId != -1">
          <span>若产品未维护对应的供应商，则需前往</span>
          <span class="btn" @click="selectSupplier({ leftId: -1, companyName: '未配置供应商' })">未配置供应商</span>
          <span>处配置。</span>
        </div>
      </div>
      <div class="search-box">
        <div class="input-item" v-if="curSupplier.companyType == 2">
          <span class="label">保司名称</span>
          <Input v-model="searchParams.companyName" placeholder="请输入" clearable @on-enter="getList()" />
        </div>
        <div class="input-item">
          <span class="label">产品名称</span>
          <Input v-model="searchParams.productName" placeholder="请输入" clearable @on-enter="getList()" />
        </div>
        <div class="input-item">
          <span class="label">产品编码</span>
          <Input v-model="searchParams.productCode" placeholder="请输入" clearable @on-enter="getList()" />
        </div>
        <div class="input-item">
          <span class="label">险种名称</span>
          <Input v-model="searchParams.productAddName" placeholder="请输入" clearable @on-enter="getList()" />
        </div>
        <div class="input-item">
          <span class="label">是否有费率</span>
          <RadioGroup v-model="searchParams.isHasCommission" @on-change="getList()">
            <Radio label="">全部</Radio>
            <Radio label="1">有费率</Radio>
            <Radio label="0">无费率</Radio>
          </RadioGroup>
        </div>
        <div class="btn-item">
          <Button type="primary" @click="getList()">搜索</Button>
          <Button type="primary" ghost @click="resetSearch()">重置</Button>
        </div>
      </div>
      <div
        class="act-box"
        v-if="
          (total == 1 && $route.query.sourceType == 1 && $route.query.fromPage == 'productManager' && activityInfoList.length) ||
          (activityInfoList.length && activityInfoList[0].mode == 1)
        "
      >
        <div
          class="item"
          v-for="(item, index) in activityInfoList"
          :key="index"
          v-if="item.mode == 1"
          @click="openPageTabTags('/activityManage/detail', { id: item.id, mode: item.mode })"
        >
          <img class="icon-img" src="@/static/images/activity-icon.png" />
          <span>活动{{ actTitleNumber(index) }}：{{ item.title }}</span>
          <span class="time">{{ item.startTime }}至{{ item.endTime }}</span>
          <img class="activity-right" src="@/static/images/activity-right.png" />
        </div>
      </div>
      <rateTable
        :list="tableData"
        :curSupplier="curSupplier"
        @reload="getList()"
        :sourceType="$route.query.sourceType"
        :fromPage="$route.query.fromPage"
        :activityInfoList="activityInfoList"
      ></rateTable>
      <div class="pageBox">
        <Page :total="total" :current="pageNum" :page-size="pageSize" show-total @on-change="getList" style="text-align: center" />
      </div>
    </div>

    <!-- 导入供应商 -->
    <import-supplier ref="importSupplier" @reload="getSupplierList()"></import-supplier>
  </div>
</template>

<script>
import { filterTime } from '@/api/filter';
import rateTable from './components/rateTable';
import importSupplier from './components/importSupplier';
import { common } from '@/api/mixins';

export default {
  mixins: [common],
  components: { rateTable, importSupplier },
  data() {
    return {
      listLoading: false,
      filterTime,
      searchParams: {
        productName: '',
        isHasCommission: '',
      },
      tableData: [],
      keyword: '',
      pageSize: 10,
      pageNum: 1,
      count: '', //当前选择的供应商产品数
      leftId: '-1', //当前选择的供应商组合id
      curSupplierName: '', //当前选择的供应商名字
      leftLoading: false,
      supplierList: [], //供应商
      activityInfoList: [],
      scroll: 0,
      total: 0
    };
  },
  computed: {
    curSupplier() {
      if (this.supplierList) {
        return this.supplierList.find(item => item.leftId == this.leftId) || {};
      } else {
        return {};
      }
    }
  },
  mounted() {
    console.log('searchParams--', this.searchParams);
    // this.initListParams('/buz/upcommission/queryUpCommissionPage');
    document.querySelectorAll('.rate-table')[0].addEventListener('scroll', this.handleScroll);
    this.getSupplierList(true);
  },
  activated() {
    let query = sessionStorage.feeUpstreamCofnigQuery;
    if (query) {
      query = JSON.parse(query);
      this.curSupplierName = query.supplierName || '未配置供应商';
      if (query.supplierId) {
        this.leftId = query.supplierId + ',' + query.supplierType;
      } else {
        this.leftId = -1;
      }
      console.log('leftId', this.leftId);
      this.$set(this.searchParams, 'companyId', query.supplierId || '-1');
      this.$set(this.searchParams, 'companyType', query.supplierType);
      this.$set(this.searchParams, 'productName', query.productName);
      this.$set(this.searchParams, 'productCode', query.productCode);
      sessionStorage.feeUpstreamCofnigQuery = '';
      this.getCount();
      this.$nextTick(() => {
        document.querySelector('.list-box .active')?.scrollIntoView();
        window.parent.postMessage(
          {
            resetFirstScroll: true,
            appMessage: true
          },
          '*'
        );
      });
    }
    this.getList();
    if (this.scroll > 0) {
      setTimeout(() => {
        document.querySelectorAll('.rate-table')[0].scrollTop = this.scroll;
        this.scroll = 0;
        document.querySelectorAll('.rate-table')[0].addEventListener('scroll', this.handleScroll);
      }, 500);
    }
  },
  deactivated() {
    if (document.querySelectorAll('.rate-table').length) {
      document.querySelectorAll('.rate-table')[0].removeEventListener('scroll', this.handleScroll);
    }
  },
  methods: {
    actTitleNumber(index) {
      let orderIndex = index + 1;
      if (this.activityInfoList.length == 1) return;
      switch (orderIndex) {
        case 1:
          return '①';
        case 2:
          return '②';
      }
    },
    handleScroll() {
      let scrollTop = document.querySelectorAll('.rate-table')[0].scrollTop;
      this.scroll = scrollTop;
    },
    // 获取供应商
    getSupplierList(first = false) {
      const params = {
        supplierName: this.keyword
      };
      this.leftLoading = true;
      this.$http({
        url: '/buz/upcommission/querySupplierList',
        type: 'GET',
        data: params
      })
        .then(res => {
          res.data.forEach(item => {
            item.leftId = item.companyId + ',' + item.companyType;
          });
          this.supplierList = res.data;
          if (first) {
            if (this.leftId != -1 && this.supplierList.find(i => i.leftId == this.leftId)) {
              this.curSupplierName = this.supplierList.find(i => i.leftId == this.leftId).companyName;
            }
            this.getCount();

            // params.companyId = this.leftId.split(',')[0];
            // params.companyType = this.leftId.split(',')[1];
            // this.searchParams = JSON.parse(JSON.stringify(params));
            this.pageNum = 1;
            this.tableData = [];
            this.getList();
          } else if (res.data[0]) {
            this.selectSupplier(res.data[0]);
          }
        })
        .finally(() => {
          this.leftLoading = false;
        });
    },
    // 选择供应商
    selectSupplier(bean) {
      this.leftId = bean.leftId;
      this.curSupplierName = bean.companyName;
      this.resetSearch();
      this.getCount();
    },
    resetSearch() {
      let params = {};
      if (this.leftId != -1) {
        params.companyId = this.leftId.split(',')[0];
        params.companyType = this.leftId.split(',')[1];
      }
      this.searchParams = JSON.parse(JSON.stringify(params));
      this.pageNum = 1;
      this.tableData = [];
      this.getList();
    },

    // 获取列表
    getList(pageNo = null) {
      pageNo ? this.pageNum = pageNo:'';
      console.log(this.pageNum)
      this.listLoading = true;
      let data = JSON.parse(JSON.stringify(this.searchParams));
      this.setListParams(data);
      this.$http({
        url: '/buz/upcommission/queryUpCommissionPage',
        type: 'POST',
        data: {
          ...data,
          pageNo: this.pageNum,
          pageSize: this.pageSize
        }
      })
        .then(res => {
          this.listLoading = false;
          this.tableData = res.data;
          this.total = res.total;
          this.activityInfoList = (res.data[0] && res.data[0].activityInfoList) || [];
        })
        .catch(e => {
          this.listLoading = false;
        });
    },
    getCount() {
      this.$http({
        url: '/buz/upcommission/queryUpProductCount',
        type: 'GET',
        data: {
          companyId: this.curSupplier.companyId || '-1',
          companyType: this.curSupplier.companyType
        }
      }).then(res => {
        this.count = res.data;
      });
    },
    setListParams(params) {
      // let query = sessionStorage.feeUpstreamCofnigQuery;
      // if (query) {
      //   query = JSON.parse(query);
      //   this.searchParams.productName = query.productName;
      //   this.curSupplierName = query.supplierName || '未配置供应商';
      //   if (query.supplierId) {
      //     this.leftId = query.supplierId + ',' + query.supplierType;
      //   } else {
      //     this.leftId = -1;
      //   }
      //   params.companyId = query.supplierId || '-1';
      //   params.companyType = query.supplierType;
      //   params.productName = query.productName;
      //   params.productCode = query.productCode;
      //   // sessionStorage.feeUpstreamCofnigQuery = '';
      //   this.getCount();
      //   this.$nextTick(() => {
      //     document.querySelector('.list-box .active')?.scrollIntoView();
      //     window.parent.postMessage(
      //       {
      //         resetFirstScroll: true,
      //         appMessage: true
      //       },
      //       '*'
      //     );
      //   });
      // } else {
      params.productName = this.searchParams.productName;
      params.companyId = this.curSupplier.companyId || '-1';
      params.companyType = this.curSupplier.companyType;
      this.tableData = [];
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>